import axios from '../../axios'

/**
 * 1.7.1 体测成绩录入
 * @returns {Promise | Promise<unknown>}
 */
export const examinRecord = data => {
  return axios({
    url: '/clubExamines/examinRecordOverview/examinRecord',
    method: 'POST',
    data
  })
}

/**
 * 1.7.2 获取体测等级卡数据
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const queryStudentExaminCardDatas = data => {
  return axios({
    url: '/clubExamines/examinRecordOverview/queryStudentExaminCardDatas/' + data.agencyId + '/' + data.studentId + '/' + data.idNo + '/' + data.birthday,
    method: 'GET'
  })
}

/**
 * 1.8.1 查询学生指定项目的最新一条测试记录
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const recordStudentNewest = data => {
  return axios({
    url: '/clubExamines/recordStudentNewest/listByStudentsToday',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/http/modules/examines/examinRecord.js